import React from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";

import styles from "./SideDrawer.module.scss";

const SideDrawer = ({ open, menuItems, navigate }) => {
  const safeMenuItems = Array.isArray(menuItems) ? menuItems : [];

  return (
    <Drawer
      variant="permanent"
      className={open ? styles.drawerOpen : styles.drawerClosed}
      classes={{
        paper: open ? styles.paperOpen : styles.paperClosed,
      }}
      PaperProps={{
        sx: {
          mt: "1.3rem",
          top: "55px",
          height: "calc(100% - 55px)",
          boxShadow: "none",
          zIndex: 1000,
        },
      }}
    >
      <div className={styles.topSpacer} />
      <Divider />

      <List>
        {safeMenuItems.length === 0 && (
          <ListItem>
            <ListItemText
              primary="No menu items"
              sx={{ textAlign: "center", color: "text.secondary" }}
            />
          </ListItem>
        )}

        {safeMenuItems.map((item) => (
          <ListItem key={item.key} disablePadding>
            <ListItemButton
              className={styles.listItemButton}
              onClick={() => navigate?.(item.path)}
            >
              <ListItemIcon className={styles.drawerIcon}>
                {item.icon}
              </ListItemIcon>

              {open && <ListItemText primary={item.label} />}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default SideDrawer;
